import Head from "next/head";
import { theme } from "../tailwind.config";

const title = "Marketing Made As Easy As Owning a Cactus";
const description =
  "Channel’s AI powered, yet easy-to-use client acquisition platform makes running marketing campaigns as easy as owning a cactus.";

export default function Meta({ children }) {
  return (
    <Head>
      <title>Channel - Small Business Marketing Automation</title>
      <meta name="viewport" content="initial-scale=1, width=device-width" />
      <meta name="theme-color" content={theme.extend.colors.brand} />
      <meta name="description" content={description} key={"description"} />

      <meta name="twitter:title" content={title} key={"twitterTitle"} />
      <meta
        name="twitter:image"
        content="/assets/images/og.png"
        key={"twitterImage"}
      />
      <meta
        name="twitter:description"
        content={description}
        key={"twitterDescription"}
      />

      <meta property="og:type" content="website" key={"ogType"} />
      <meta property="og:title" content={title} key={"ogTitle"} />
      <meta
        property="og:image"
        content="/assets/images/og.png"
        key={"ogImage"}
      />
      <meta
        property="og:description"
        content={description}
        key={"ogDescription"}
      />
    </Head>
  );
}
